import { Injectable } from '@angular/core';
import { CanActivate, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardSuperAdmin implements CanActivate, CanActivateChild{

  constructor(public auth: AuthService, private router: Router) {}

  canActivate() {
    return this.auth.isSuperAdmin();
  }

  canActivateChild() {
    return this.auth.isSuperAdmin();
  }

}



// WEBPACK FOOTER //
// ./client/app/core/auth/auth-guard-superadmin.service.ts